export const BOOKING_STATUS_FILTERS = [
  { key: "all", label: "All", tone: "all" },
  { key: "payment_verification", label: "Payment Verification", tone: "review" },
  { key: "extension_requests", label: "Extension Requests", tone: "review" },
  { key: "awaiting_payment", label: "Awaiting Payment", tone: "payment" },
  { key: "confirmed", label: "Confirmed", tone: "confirmed" },
  { key: "active", label: "Active / Ongoing", tone: "confirmed" },
  { key: "completed", label: "Completed", tone: "completed" },
  { key: "cancelled", label: "Cancelled", tone: "cancelled" },
  { key: "archived", label: "Archived", tone: "cancelled" },
];

const BOOKING_STATUS_GROUPS = {
  in_progress: {
    label: "In Progress",
    subtext: "Customer has not yet submitted a booking",
    tone: "progress",
    statuses: ["draft", "pending_verification", "ready_to_continue"],
  },
  booking_review: {
    label: "Booking Details Verification",
    subtext: "Booking submitted. Review customer details and issue invoice.",
    tone: "review",
    statuses: [
      "submitted",
      "pending_booking_review",
      "pending_admin_review",
      "pending_approval",
      "pending",
    ],
  },
  awaiting_payment: {
    label: "Awaiting Payment",
    subtext: "Invoice issued. Waiting for customer payment.",
    tone: "payment",
    statuses: ["pending_payment", "awaiting_payment", "invoice_issued"],
  },
  payment_verification: {
    label: "Payment Verification",
    subtext: "Payment proof submitted. Vehicle and dates are temporarily reserved.",
    tone: "review",
    statuses: [
      "payment_submitted",
      "payment_verification",
      "payment_under_review",
      "pending_payment_verification",
      "under_review",
    ],
  },
  confirmed: {
    label: "Confirmed",
    subtext: "Booking confirmed and payment verified",
    tone: "confirmed",
    statuses: ["approved", "booked_confirmed", "confirmed"],
  },
  active: {
    label: "Active / Ongoing",
    subtext: "Trip is active or ongoing",
    tone: "confirmed",
    statuses: ["active", "ongoing"],
  },
  completed: {
    label: "Completed",
    subtext: "Trip completed successfully",
    tone: "completed",
    statuses: ["completed"],
  },
  cancelled: {
    label: "Cancelled",
    subtext: "Booking is closed",
    tone: "cancelled",
    statuses: ["rejected", "cancelled", "cancelled_conflict", "expired", "payment_rejected"],
  },
};

export function getBookingStatusMeta(status) {
  const normalized = String(status || "").toLowerCase();
  const key =
    Object.keys(BOOKING_STATUS_GROUPS).find((groupKey) =>
      BOOKING_STATUS_GROUPS[groupKey].statuses.includes(normalized)
    ) || "booking_review";

  return {
    key,
    ...BOOKING_STATUS_GROUPS[key],
  };
}

export function getBookingStatusLabel(status) {
  return getBookingStatusMeta(status).label;
}

export function getBookingStatusTone(status) {
  return getBookingStatusMeta(status).tone;
}

export function getBookingStatusSubtext(status) {
  return getBookingStatusMeta(status).subtext;
}

export function getBookingStatusClass(status) {
  return `booking-status booking-status--${getBookingStatusTone(status)}`;
}
